import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import antImg from '../../asset/img/main_taxresult_ant_img.svg';
import pigImg from '../../asset/img/main_taxresult_pig_img.svg';
import mascotImg from '../../asset/img/main_mascot_img.png';

import Typography from '../../components/common/Typography';
import Button from '../../components/common/Button';
import Badge from '../../components/common/Badge';
import { formatNumber } from '../../common/Util';
import { TaxResultBox } from '../../asset/styled/MainStyled';

const MESSAGE_TYPE = {
  AFTER_DEADLINE: 0, // 보이기마감 후
  AFTER_CERTIFY: 1, // 인증후
  BEFORE_CERTIFY: 2, // 인증전
};

const TaxNotification = () => {
  const { t } = useTranslation('main');
  const navigate = useNavigate();
  const [isResult, setIsResult] = useState('2');
  // const { resultData } = useSelector(state => state.resultQuery);
  const { isCertify, resultDataView: resultData } = useSelector(state => state.common);
  const { myInfo } = useSelector(state => state.myInfo);

  useEffect(() => {
    //1 : 결과보임 2: 안보임
    let _isResult = resultData.htmViewMagam;
    if (isCertify) _isResult = '1';

    setIsResult(_isResult);
  }, [resultData]);

  const handleStartButton = () => {
    let url = '/previousEmployment';
    if (resultData.htmViewMagam == '1') {
      url = '/resultQuery';
    }
    navigate(url);
  };

  const message = useMemo(() => {
    const messages = [
      {
        title: t('message3'),
        content: t('message_2_2'),
        underline: t('message_underline2'),
        button: t('startButton2'),
      },
      {
        title: t('message2'),
        content: t('message_2_1'),
        underline: t('message_underline1'),
        button: t('startButton2'),
      },
      {
        title: t('message'),
        content: t('message_2'),
        underline: t('message_underline'),
        button: t('startButton'),
      },
    ];

    if (resultData.htmViewMagam === '1') {
      return messages[MESSAGE_TYPE.AFTER_DEADLINE];
    }
    return messages[isResult] || messages[MESSAGE_TYPE.BEFORE_CERTIFY];
  }, [t, resultData.htmViewMagam, isResult]);

  return (
    <div className="tax-notification">
      <div className="notification-content">
        <div>
          <span className="subtitleBold">{myInfo?.htmInsaPerNm}</span>
          <span className="subtitleMedium">님</span>
        </div>
        <Typography variant="titleH5" color="GrayScale-700">
          {message.title}
          <br />
          {message.content}
          <span className="titleH5 decoration_underline">{message.underline}</span>
        </Typography>
      </div>
      <Button
        className="start-button"
        value={message.button}
        style={{ borderRadius: '30px' }}
        onClick={handleStartButton}
        alt={message.button}
      />
      {/* 서명 전, 후 */}
      {isResult == '1' ? <TaxResult /> : <TaxResultBefore />}
    </div>
  );
};

export default TaxNotification;

// 검토 후 결과화면
export const TaxResult = () => {
  const { t } = useTranslation('main');
  const { resultDataView: resultData } = useSelector(state => state.common);

  const taxResult = [
    {
      //월급날 검토결과
      title: t('pigText'),
      amount: resultData?.htmViewMagam == '1' ? resultData?.htmYAResultMony || 0 : '',
      badge: resultData?.htmViewMagam == '1' ? resultData?.htmYAResultTxt || '' : '검토중',
      img: pigImg,
      alt: `${t('pigText')} ${resultData?.htmYAResultTxt || '검토중'} ${
        resultData?.htmYAResultMony || ''
      }`,
    },
    {
      //근로자 검토결과
      title: t('antText'),
      amount: resultData?.htmPerResultMony || 0,
      badge: resultData?.htmPerResultTxt || '',
      img: antImg,
      alt: `${t('antText')} ${resultData?.htmPerResultTxt || ''} ${
        resultData?.htmPerResultMony || ''
      }`,
    },
  ];

  return (
    <div className="displayFlexColumn" style={{ width: '100%', gap: '8px' }}>
      {taxResult.map((result, index) => (
        <TaxResultBox key={index}>
          <div className="displayFlexColumn" style={{ gap: '2px' }}>
            <Typography variant="body2Bold">{result.title}</Typography>
            <div className="displayFlex" style={{ gap: '8px' }}>
              <Badge color="custom">{result.badge}</Badge>
              <Typography variant="body2Medium">{result.amount}</Typography>
            </div>
          </div>
          <img src={result.img} alt={result.alt} />
        </TaxResultBox>
      ))}
      <div></div>
    </div>
  );
};

//검토 전 결과화면
const TaxResultBefore = () => {
  const { t } = useTranslation('main');
  const { resultDataView: resultData } = useSelector(state => state.common);

  return (
    <div
      style={{
        padding: '0px 24px',
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        backgroundImage: `url(${mascotImg})`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right',
        height: '150px',
      }}>
      <div>
        <Typography variant="body2Bold">{t('expectedResultText')}</Typography>
        <div className="displayFlex" style={{ gap: '8px' }}>
          <Badge color="custom">{resultData?.htmPerResultTxt || ''}</Badge>
          <Typography variant="body2Medium">{resultData?.htmPerResultMony || ''}</Typography>
        </div>
      </div>
    </div>
  );
};
